import { Component, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { AdminService } from '../../services/admin.service'
import { HttpStatusCode } from '@angular/common/http'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'app-admin-referrals',
  templateUrl: './admin-referrals.component.html',
  styleUrls: ['../admin-table.css', './admin-referrals.component.css'],
})
export class AdminReferralsComponent implements OnInit {
  leaderboard: any[] = []
  loading = false
  page = 1
  limit = 20
  totalReferrals: number | null = null
  readonly pageSizeOptions = [10, 20, 50, 100]
  searchControl = new FormControl('', [])

  constructor(public adminService: AdminService) {}

  ngOnInit(): void {
    this.loadLeaderboard()
    this.searchControl.valueChanges.subscribe(() => {
      this.page = 1
      this.loadLeaderboard()
    })
  }

  loadLeaderboard(): void {
    this.loading = true
    const search = this.searchControl.value?.trim() || undefined
    this.adminService.getReferralLeaderboard({ page: this.page, limit: this.limit, search }).subscribe({
      next: (res: any) => {
        this.loading = false
        if (res.status === HttpStatusCode.Ok && res.body) {
          this.leaderboard = Array.isArray(res.body) ? res.body : res.body.leaderboard ?? res.body.data ?? []
          this.totalReferrals = res.body.total ?? res.body.count ?? this.leaderboard.length
        }
      },
      error: () => {
        this.loading = false
        this.adminService.showNotification('Failed to load referral leaderboard', 5000, 'Close')
      },
    })
  }

  onPageChange(event: PageEvent): void {
    this.limit = event.pageSize
    this.page = event.pageIndex + 1
    this.loadLeaderboard()
  }

  rank(index: number): number {
    return (this.page - 1) * this.limit + index + 1
  }

  referrerDisplay(r: any): string {
    const name = [r.first_name, r.last_name].filter(Boolean).join(' ')
    return name || r.email || r.state_code || `#${r.id}`
  }
}
